import CryptoJS from 'crypto-js';
import { getCookie } from '../utiles/utiles';
import { getRequestHeaders, ws3 } from "./signHeader";
import { ENUM_HOST, ENUM_COOKIE_NAME } from '../enum/API';

class APICore {
    private headers: Headers;
    private url: string;
    private endPoint: string;

    constructor() {
        this.endPoint = '';
        this.url = '';
        this.headers = new Headers();
    }

    protected setEndPoint(endPoint: string): void {
        this.endPoint = endPoint;
    }

    protected async getHeaders(): Promise<Headers> {
        return new Promise(resolve => {
            // TOKEN 확인, 토큰이 존재하지 않을 경우 비인증 통신을 위한 url 변경
            if (!getCookie(ENUM_COOKIE_NAME.AUTH)) {
                this.url = ENUM_HOST.PUBLIC + this.endPoint;
                this._getToken(this.endPoint).then(token => {
                    const signature: string = CryptoJS.enc.Base64.stringify(
                        CryptoJS.SHA256(`${this.endPoint}${token}`)
                    );
                    this.headers.append('signature', signature);
                    resolve(this.headers);
                });
            } else {
                this.url = ENUM_HOST.AUTH + this.endPoint;
                const headersInfo = getRequestHeaders(this.url);
                this.headers.append(ws3, headersInfo[ws3]);
                this.headers.append('transaction-id', headersInfo['transaction-id']);
                this.headers.append('client-id', headersInfo['client-id']);
                this.headers.append('authorization', headersInfo.authorization.toString());
                this.headers.append('service', headersInfo.service);
                this.headers.append('timestamp', headersInfo.timestamp.toString());
                resolve(this.headers);
            }
        });
    }

    protected getUrl(): string {
        return this.url;
    }

    /**
     * 토큰을 얻어온다. (비인증용)
     */
    private _getToken(endPoint: string) {
        const apiUrl = `${ENUM_HOST.PUBLIC_GET_OEKN}${endPoint}`;
        return new Promise(async (resolve, reject) => {
            try {
                const data = await fetch(apiUrl);
                data.json().then(result => {
                    resolve(`${result.cur_date}${result.token}`);
                });
            } catch (error) {
                reject(new Error(error));
            }
        });
    }
}

export default APICore;
